import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fbdc754"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between align-items-end gap-4 sm:hidden px-3" }
const _hoisted_2 = { class: "relative flex align-items-center mt-4 w-22rem" }
const _hoisted_3 = {
  key: 0,
  class: "icon-warpit_icon_search absolute right-0 mr-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_map-import font-bold text-base" }, null, -1))
const _hoisted_5 = { class: "sm:flex justify-content-between align-items-center bg-primary-100 px-3 sm:border-round-lg w-full mt-4 sm:mt-6" }
const _hoisted_6 = { class: "relative hidden sm:flex align-items-center w-22rem py-4 flex-shrink-0" }
const _hoisted_7 = {
  key: 0,
  class: "icon-warpit_icon_search absolute right-0 mr-3 hidden sm:inline-block"
}
const _hoisted_8 = { class: "flex gap-1 justify-content-between sm:justify-content-end align-items-center w-full py-3" }
const _hoisted_9 = { class: "flex flex-column sm:flex-row gap-2 sm:align-items-center" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_GMapAutocomplete, {
          class: "addressSearch",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.address = $event.target.value)),
          onPlace_changed: _cache[1] || (_cache[1] = (place) => _ctx.$emit('addressChange', place)),
          options: {
          componentRestrictions: { country: 'si' },
        },
          value: _ctx.address,
          placeholder: _ctx.$t(_ctx.searchPlaceholderKey),
          id: "address",
          maxlength: "255"
        }, null, 8, ["value", "placeholder"]),
        (_ctx.address === null)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.address !== null)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearAddress && _ctx.clearAddress(...args))),
              class: "icon-warpit_icon_x absolute right-0 mr-3 cursor-pointer"
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Button, {
        class: "parkingRoundButton",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('mapMode')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_GMapAutocomplete, {
          class: "addressSearch hidden sm:inline-block",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.address = $event.target.value)),
          onPlace_changed: _cache[5] || (_cache[5] = (place) => _ctx.$emit('addressChange', place)),
          options: {
          componentRestrictions: { country: 'si' },
        },
          value: _ctx.address,
          placeholder: _ctx.$t(_ctx.searchPlaceholderKey),
          id: "address",
          maxlength: "255"
        }, null, 8, ["value", "placeholder"]),
        (_ctx.address === null)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.address !== null)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearAddress && _ctx.clearAddress(...args))),
              class: "icon-warpit_icon_x absolute right-0 mr-3 cursor-pointer hidden sm:inline-block"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.selectedSorting,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedSorting) = $event)),
            options: _ctx.sortOptions,
            optionLabel: "name",
            optionValue: "value",
            onChange: _cache[8] || (_cache[8] = (event) => _ctx.$emit('sortingChange', event.value))
          }, {
            value: _withCtx(({ value }) => [
              _createElementVNode("div", _hoisted_10, [
                (value === 'distance')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t("parking.sort_by")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("parking.sort_by_distance")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (value === 'occupancy')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.$t("parking.sort_by")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("parking.sort_by_occupancy")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            option: _withCtx(({ option }) => [
              _createElementVNode("div", _hoisted_13, [
                (option.value === 'distance')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t("parking.sort_by")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("parking.sort_by_distance")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (option.value === 'occupancy')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.$t("parking.sort_by")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("parking.sort_by_occupancy")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _renderSlot(_ctx.$slots, "types", {}, undefined, true)
      ])
    ])
  ], 64))
}